// Recharts, but deferred.
import React from 'react'
import loadable from '@loadable/component'

import XAxis from 'recharts/lib/cartesian/XAxis'
import YAxis from 'recharts/lib/cartesian/XAxis'
import Line from 'recharts/lib/cartesian/Line'
import CartesianGrid from 'recharts/lib/cartesian/CartesianGrid'
import Tooltip from 'recharts/lib/component/Tooltip'
import Legend from 'recharts/lib/component/Legend'
import Bar from 'recharts/lib/cartesian/Bar'
import Pie from 'recharts/lib/polar/Pie'
import ResponsiveContainer from 'recharts/lib/component/ResponsiveContainer'

const Recharts = loadable.lib(() => import('recharts'))
const LineChart = (props) => {
  return (
    <Recharts fallback={<>recharts fallback</>}>
      {(module) => <>{module && <module.LineChart {...props}/>}</>}
    </Recharts>
  )
}
const BarChart = React.forwardRef((props, ref) => {
  return (
    <Recharts fallback={<>recharts fallback</>}>
      {(module) => <>{module && <module.BarChart ref={ref} {...props}/>}</>}
    </Recharts>
  )
})
const PieChart = React.forwardRef((props, ref) => (
  <Recharts fallback={<>recharts fallback</>}>
    {(module) => <>{module && <module.PieChart ref={ref} {...props}/>}</>}
  </Recharts>
))
const Cell = (props) => {
  return (
    <Recharts fallback={<>recharts fallback</>}>
      {(module) => <>{module && <module.Cell {...props}/>}</>}
    </Recharts>
  )
}
const Label = (props) => {
  return (
    <Recharts fallback={<>recharts fallback</>}>
      {(module) => <>{module && <module.Label {...props}/>}</>}
    </Recharts>
  )
}

export default {
  BarChart,
  XAxis,
  YAxis,
  Line,
  CartesianGrid,
  Tooltip,
  Legend,
  Bar,
  PieChart,
  Pie,
  Cell,
  Label,
  ResponsiveContainer,
  LineChart
}
